import {gql} from "@apollo/client";

const publicMentorIntroMessageQuery = gql`
    query MentorIntroMessageQuery($mentorId: String, $isDegreeTypesEnabled: Boolean = false) {
        publicMentorIntroMessage(mentorId: $mentorId) {
            introMessage {
                id
                text
                sender {
                    id
                    firstName
                    profilePhoto
                    accountRole
                    prospectWelcomeMessage
                    degreeLevel
                    degree {
                        id
                        name
                    }
                    degrees @include(if: $isDegreeTypesEnabled) {
                        degreeType
                        degree {
                            id
                            name
                        }
                    }
                    university {
                        id
                        name
                        isEnterprise
                    }
                    staffFields {
                        bio
                        department
                        role
                    }
                    year
                }
                chatGroupId
                created
                visible
            }
        }
    }
`;

export default publicMentorIntroMessageQuery;
